<template>
  <v-container fluid>
    <v-card tile>
      <div class="pl-6">
        <p class="text-body-1 font-weight-regular pt-4">
          Total gestiones:
          {{ totalRegistros }} <v-chip x-small outlined class="ml-1">historico</v-chip>
        </p>
        <div v-html="formatearParametros()"></div>

        <p class="text-caption text--secondary font-weight-bold mt-n3 pb-4" v-if="selectedFecha && selectedFecha[0]">
          <v-icon class="" color="black">mdi-calendar-range</v-icon>
          del {{ selectedFecha[0] }} al {{ selectedFecha[1] }}
        </p>
        <p class="text-caption text--secondary font-weight-bold mt-n3 pb-4" v-else>

        </p>
      </div>
    </v-card>

    <v-row>
      <!-- Recuadro para la tabla -->
      <v-col cols="10">
        <v-data-table :loading="table_loading" disable-pagination :options.sync="options" :hide-default-footer="true"
          :headers="headers" :items="datosTabla" item-key="name" class="elevation-2" @click:row="handleClick">
          <template v-slot:[`item.resultado_evaluacion`]="{ item }">
            <v-chip small v-if="item.resultado_evaluacion == 'rechazado'"
              :color="item.resultado_evaluacion == 'rechazado' ? 'red' : ''" dark>
              ROJO
            </v-chip>
            <v-chip small v-if="item.resultado_evaluacion == 'revisión'"
              :color="item.resultado_evaluacion == 'revisión' ? 'yellow accent-2' : ''">
              AMARILLO
            </v-chip>
            <v-chip small v-if="item.resultado_evaluacion == 'aprobado'"
              :color="item.resultado_evaluacion == 'aprobado' ? 'green' : ''" dark>
              VERDE
            </v-chip>
          </template>
          <!-- /**exportar registros a documento de excel */ -->
          <template v-slot:top>
            <v-row no-gutters>
              <v-spacer>
              </v-spacer>
              <v-btn x-small @click="exportToExcel" class="mt-3 ml-1 mr-1 flo" color="success">
                Exportar a Excel
              </v-btn>
            </v-row>
          </template>
          <!-- /**exportar registros a documento de excel, fin */ -->
          <template v-slot:[`item.deudor`]="{ }"> deudor </template>
          <template v-slot:[`item.flag_tiene_pedido`]="{ item }">
            <span v-if="item.flag_tiene_pedido === 0">No</span>
            <span v-if="item.flag_tiene_pedido === 1">Si</span>
            <span v-if="item.flag_tiene_pedido === null">-</span>

          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ fnGetDateTime(item.createdAt) }}
          </template>
          <template v-slot:[`item.flag_precalificacion_concluidas_fecha`]="{ item }">
            {{ fnGetDateTime(item.flag_precalificacion_concluidas_fecha) }}
          </template>
          <template v-slot:[`item.fecha_de_nacimiento`]="{ item }">
            {{ fnGetDateUTC(item.fecha_de_nacimiento) }}
          </template>
          <template v-slot:[`item.fecha_ultimo_complemento_cargado`]="{ item }">
            {{ fnGetDateTime(item.fecha_ultimo_complemento_cargado) }}
          </template>
          <template v-slot:[`item.flag_precalificacion_cancelada_fecha`]="{ item }">
            {{ fnGetDateTime(item.flag_precalificacion_cancelada_fecha) }}
          </template>
          <template v-slot:[`item.fecha_campania`]="{ item }">
            {{ fnGetDateUTC(item.fecha_campania) }}
          </template>
          <template v-slot:[`item.flag_precalificacion_listo_para_aprobacion_fecha`]="{ item }">
            {{ fnGetDate(item.flag_precalificacion_listo_para_aprobacion_fecha) }}
          </template>
          <template v-slot:[`item.flag_precalificacion_completada_fecha`]="{ item }">
            {{ fnGetDate(item.flag_precalificacion_completada_fecha) }}
          </template>
          <!-- verificamos si tiene un fiador -->
          <template v-slot:[`item.fiador`]="{ item }">
            <span v-if="!item.fiador_nombre_completo">-</span>
            <span v-if="item.fiador_nombre_completo">{{ item.fiador_nombre_completo }}</span>
          </template>



          <!-- Compromiso aprobado -->
          <template v-slot:[`item.compromiso_aprobado`]="{ item }">
            <span v-if="item.compromiso_aprobado === 1">Si</span>
            <span v-else>-</span>
          </template>

          <!-- Rectificaciones completadas como Si/No -->
          <template v-slot:[`item.rectificaciones_completadas`]="{ item }">
            <span v-if="item.rectificaciones_completadas == 1">Si</span>
            <span v-if="item.rectificaciones_completadas == 0">No</span>
            <span v-if="item.rectificaciones_completadas == null">-</span>
          </template>

          <!-- para el botón de VER -->
          <template v-slot:[`item.ver`]="{ item }">
            <v-btn x-small dark color="#031D6A" @click="fnVerRegistro(item)">VER</v-btn>
          </template>
        </v-data-table>
        <!-- PAGINACION -->
        <v-col cols="12">
          <v-col offset="9" cols="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Registros por página"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col class="">
            Total de registros: {{ totalRegistros }}
            <v-pagination class="float-right" v-model="page" :length="totalPages" total-visible="15"
              next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
          </v-col>
        </v-col>
        <!-- FIN PAGINACION -->
      </v-col>

      <!-- recuadro para los parámetros de búsqueda -->
      <v-col cols="2">
        <v-card tile>
          <div class="pt-2">
            <p class="text-body-2 font-weight-medium text--secondary pl-4">
              Parámetros de búsqueda
            </p>

            <v-card-text class="mt-n6">

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar" v-model="id"
                label="ID / No. de gestión" prepend-icon="mdi-database-search" dense></v-text-field>


              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar" v-model="sap"
                label="Código SAP" prepend-icon="mdi-database-search" dense></v-text-field>

              <v-select @change="fnAplicarParametros" clearable hint="Enter para filtrar"
                v-model="EstadoDeLaGestion" :items="itemsEstadosDeLaGestion" label="Estado de la gestion"
                prepend-icon="mdi-database-search" dense></v-select>



              <v-menu ref="fechaAprobacionDialog" v-model="modalAprobacionFechas" :close-on-content-click="false"
                :nudge-right="-17" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="selectedAprobacionFecha" label="Fecha aprobación" prepend-icon="mdi-calendar" readonly
                    v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarselectedAprobacionFecha" range :max="disabledFecha"
                  color="primary" header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalAprobacionFechas = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary"
                    @click="$refs.fechaAprobacionDialog.save(dialogVarselectedAprobacionFecha)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar" v-model="nombre"
                label="Deudor" prepend-icon="mdi-database-search" class="" dense></v-text-field>

              <v-menu ref="fechaDeNacimientoDialog" v-model="modalFechaDeNacimiento" :close-on-content-click="false"
                :nudge-right="-17" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="SelectedFechasDeNacimiento" label="Fecha de nacimiento" prepend-icon="mdi-calendar"
                    readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarSelectedFechasDeNacimiento" range :max="disabledFecha"
                  color="primary" header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechaDeNacimiento = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary"
                    @click="$refs.fechaDeNacimientoDialog.save(dialogVarSelectedFechasDeNacimiento)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="search_nit" label="NIT" prepend-icon="mdi-database-search" dense></v-text-field>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="documentoIdentificacion" label="Documento identificación" prepend-icon="mdi-database-search"
                dense></v-text-field>

              <v-select @change="fnAplicarParametros" clearable hint="Enter para filtrar"
                v-model="searchTipoDeCliente" :items="itemssearchTipoDeCliente" label="Tipo de cliente"
                prepend-icon="mdi-database-search" dense></v-select>

              <v-menu ref="fechaDialog" v-model="modalFechas" :close-on-content-click="false" :nudge-right="-17"
                transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="selectedFecha" label="Fecha de sincronización" prepend-icon="mdi-calendar" class=""
                    readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarSelectedFecha" range :max="disabledFecha" color="primary"
                  header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechas = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.fechaDialog.save(dialogVarSelectedFecha)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="nombre_fiador" label="Fiador" prepend-icon="mdi-database-search" class="" dense></v-text-field>

              <v-select @change="fnAplicarParametros" clearable hint="Enter para filtrar"
                v-model="resultadoEvaluacion" :items="itemsResultadoEvaluacion" label="Resultado evaluación"
                prepend-icon="mdi-database-search" dense></v-select>

              <v-menu ref="fechaCampaniasDialog" v-model="modalFechaCampania" :close-on-content-click="false"
                :nudge-right="-17" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="SelectedFechasCampania" label="Fecha de evaluación" prepend-icon="mdi-calendar" readonly
                    v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarSelectedFechasCampania" range :max="disabledFecha"
                  color="primary" header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechaCampania = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.fechaCampaniasDialog.save(dialogVarSelectedFechasCampania)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="campania" label="Campaña" prepend-icon="mdi-database-search" dense></v-text-field>

              <v-select @change="fnAplicarParametros" clearable hint="Enter para filtrar"
                v-model="search_pedido" :items="itemsPedido" label="Con o sin pedido" prepend-icon="mdi-database-search"
                dense></v-select>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="usuarios" label="Agente de comercio" prepend-icon="mdi-database-search" dense></v-text-field>

              <v-menu ref="fechaDecancelacionDialog" v-model="modalFechasCancelacion" :close-on-content-click="false"
                :nudge-right="-17" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="SelectedCancelacionFechas" label="Fecha cancelación" prepend-icon="mdi-calendar" readonly
                    v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarSelectedCancelacionFechas" range :max="disabledFecha"
                  color="primary" header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechasCancelacion = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary"
                    @click="$refs.fechaDecancelacionDialog.save(dialogVarSelectedCancelacionFechas)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu ref="fechaUltimoComplementoDialog" v-model="modalFechaUltimoComplemento"
                :close-on-content-click="false" :nudge-right="-17" transition="scale-transition" offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                    v-model="SelectedFechasUltimoComplemento" label="Complementos cargados" prepend-icon="mdi-calendar"
                    readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240"
                  no-title scrollable v-model="dialogVarSelectedFechasUltimoComplemento" range :max="disabledFecha"
                  color="primary" header-color="primary">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechaUltimoComplemento = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="primary"
                    @click="$refs.fechaUltimoComplementoDialog.save(dialogVarSelectedFechasUltimoComplemento)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="search_tiempo_gestion" label="Tiempo total de gestión" prepend-icon="mdi-database-search"
                dense></v-text-field>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar" v-model="sector"
                label="Sector" prepend-icon="mdi-database-search" dense></v-text-field>


              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar" v-model="region"
                label="Región" prepend-icon="mdi-database-search" dense></v-text-field>

              <v-text-field @keydown.enter="fnAplicarParametros()" clearable hint="Enter para filtrar"
                v-model="division" label="División" prepend-icon="mdi-database-search" dense></v-text-field>


              <v-checkbox @change="compromiso_aprobado" v-model="compromiso_aprobado" label="Compromiso aprobado"
                prepend-icon="mdi-database-search" dense></v-checkbox>

              <!-- un v select para rectificaciones completadas (rectificaciones_completadas) -->
              <v-select @change="fnAplicarParametros" clearable hint="Enter para filtrar"
                v-model="rectificaciones_completadas" :items="itemsRectificacionesCompletadas"
                label="Rectificaciones completadas" prepend-icon="mdi-database-search" item-text="text"
                item-value="value" dense></v-select>

            </v-card-text>
          </div>
          <v-card-actions class="justify-end pb-6 mt-n4">
            <v-btn small color="#031D6A" class="white--text mr-1" @click="fnAplicarParametros()">
              APLICAR PARÁMETROS
              <v-icon small class="ml-2">mdi-magnify</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- para el recuadro que indica que Se aprobó exitosamente el crédito-->
    <v-snackbar v-model="snackbar" timeout="3500" color="success" right top class="mt-14">
      <v-row>
        <v-col cols="1" md="1">
          <v-icon>mdi-check-circle</v-icon>
        </v-col>
        <v-col cols="11" md="11">
          <div class="text-center">
            <p class="text-subtitle-2 font-weight-medium white--text">
              Se aprobó exitosamente el crédito
            </p>
            <p class="text-subtitle-2 font-weight-medium white--text mt-n4 mb-n1">
              para la evaluación #{{ numeroEvaluacion }}
            </p>
          </div>
        </v-col>
      </v-row>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from 'moment';
require('moment/locale/es.js');
import { mapActions } from 'vuex';
export default {
  name: 'gestionesListasParaAprobacion',
  data() {
    return {
      table_loading: false,
      compromiso_aprobado: null,
      itemsRectificacionesCompletadas: [{ text: 'No', value: 0 }, { text: 'Si', value: 1 }],
      rectificaciones_completadas: null,
      campania: null,
      //paginacion
      options: {},
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [10, 25, 50, 100],
      totalRegistros: 0,
      //paginacion fin
      //variables para la info de la ventana verde superior derecha, cuando se finalizó una revisión exitosa
      snackbar: false,
      numeroEvaluacion: 33256,

      dialogIniciarProceso: false, //para mostrar la ventana de dialogo que contiene los detalles de la evaluacion
      totalGestionesEnRevision: 20, //variable temporal para mostrar el número total de precalificaciones completadas que se muestra en la card superior
      fechaSelect: '', // fecha de prueba que se muestra en la card superior

      //encabezados para la tabla
      headers: [
        {
          text: 'Número evaluación',
          align: 'start',
          value: 'id',
          sortable: true,
          type: 'integer'
        },
        {
          text: 'Código SAP',
          align: 'start',
          value: 'codigo_sap',
          sortable: true,
        },
        { text: 'Estado de la gestión', value: 'estado', type: 'string' },
        { text: 'Fecha aprobación', value: 'flag_precalificacion_concluidas_fecha', type: 'datetime', width: 160 },
        {
          text: 'Nombre persona',
          value: 'deudor_nombre_completo',
          type: 'string',
          width: 180
        },
        {
          text: 'Fecha de nacimiento',
          align: 'start',
          value: 'fecha_de_nacimiento',
          sortable: false,
          width: 150,
          type: 'date'
        },
        {
          text: 'NIT',
          align: 'start',
          value: 'nit',
          sortable: false,
        },
        {
          text: 'Documento de identificación',
          value: 'dpi',
          type: 'string',
        },
        {
          text: 'Tipo de cliente',
          align: 'start',
          value: 'buro_tipo_de_usuario',
          sortable: false,
        },
        {
          text: 'Fecha de sincronización',
          align: 'start',
          value: 'createdAt',
          sortable: false,
          width: 180,
          type: 'datetime'
        },
        {
          text: 'Fiador',
          align: 'start',
          value: 'fiador_nombre_completo',
          sortable: false,
          type: 'string',
        },

        { text: 'Resultado evaluación', value: 'resultado_evaluacion', type: 'string' },
        { text: 'Fecha de evaluación', value: 'fecha_campania', type: 'date', width: 150 },
        { text: 'Fecha campaña', value: 'campania', type: 'date', width: 150 },
        {
          text: 'Código de usuario',
          align: 'start',
          value: 'CREADO_POR_USUARIO',
          sortable: false,
          type: 'string'
        },
        {
          text: 'Nombre de usuario',
          align: 'start',
          value: 'CREADO_POR_USUARIO_NOMBRE',
          sortable: false,
          width: 180,
          type: 'string'
        },
        { text: 'Fecha cancelación', value: 'flag_precalificacion_cancelada_fecha', type: 'datetime', width: 160 },
        { text: 'Complementos cargados', value: 'fecha_ultimo_complemento_cargado', type: 'datetime', width: 160 },
        { text: 'Tiempo total de gestión', value: 'tiempo_transcurrido_total', type: 'string', width: 160 },
        { text: 'Con o Sin pedido', align: 'start', value: 'flag_tiene_pedido', sortable: false, type: 'boolean' },
        { text: 'Sector', value: 'sector', type: 'string' },
        { text: 'Region', value: 'region', type: 'string' },
        { text: 'División', value: 'division', type: 'string', width: 100 },
        { text: 'Compromiso aprobado', value: 'compromiso_aprobado', type: 'boolean', align: 'center' },
        { text: 'Rectificaciones completadas', value: 'rectificaciones_completadas', type: 'boolean', align: 'center' },
        { text: 'Ver', align: 'center', value: 'ver', sortable: false },
      ],

      //datos para mostrar en la tabla (se tiene un dato de prueba)
      datosTabla: [],

      //--------------variables para el cuadro de búsqueda

      //variables para la fecha
      modalFechas: false,
      dialogVarSelectedFecha: null,
      selectedFecha: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas
      disabledFecha: moment().format('YYYY-MM-DD'),


      //variables para la fecha
      modalAprobacionFechas: false,
      dialogVarselectedAprobacionFecha: null,
      selectedAprobacionFecha: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas

      modalFechaCampania: false,
      dialogVarSelectedFechasCampania: null,
      SelectedFechasCampania: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas

      modalFechaDeNacimiento: false,
      dialogVarSelectedFechasDeNacimiento: null,
      SelectedFechasDeNacimiento: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas

      modalFechaUltimoComplemento: false,
      dialogVarSelectedFechasUltimoComplemento: null,
      SelectedFechasUltimoComplemento: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas

      modalFechasCancelacion: false,
      dialogVarSelectedCancelacionFechas: null,
      SelectedCancelacionFechas: [
        null,
        null
      ], //en esta variable es donde se almacenará la fecha o el rango de fechas

      nombre: null, //almacenamos el nombre para los parámetros de búsqueda
      nombre_fiador: null,
      search_nit: null,
      search_pedido: null,
      documentoIdentificacion: null,
      perfilPersona: null,
      resultadoEvaluacion: null,
      EstadoDeLaGestion: null,
      usuarios: null,
      sector: null,
      region: null,
      division: null,
      ruta: null,
      id: null,
      sap: null,
      searchTipoDeCliente: null,
      search_tiempo_gestion: null,
      //Valores con valores temporales
      itemsPerfilPersona: ['Deudor', 'random', 'otro'],
      itemsResultadoEvaluacion: ['VERDE', 'ROJO', 'AMARILLO'],
      itemsPedido: ['Si', 'No'],
      itemssearchTipoDeCliente: ["nuevo", "reingreso"],
      itemsEstadosDeLaGestion: [
        "Precalificacion incompleta",
        "Precalificacion completada",
        "En revisión",
        "Con Pendientes",
        "Con rectificación",
        "Con rectificación y pendientes",
        "Con compromiso de pago",
        "Lista para aprobación",
        "Lista para aprobación con compromiso de pago",
        "Gestión concluida",
        "Gestión cancelada",
        "Gestión eliminada"],
      itemsUsuarios: ['user1', 'user2', 'user3'],
      itemsSector: ['95', '56', '88'],
      itemsRuta: ['EMP095', 'SER765', 'RTG123'],

      detalleEvaluacion: {}, //para mostrar la info en la ventana de dialogo
    };
  },

  methods: {
    formatearParametros() {
      const params = this.getParams();
      
      // Filtrar los atributos que no queremos mostrar
      const excluir = ['createdAt', 'fecha_de_nacimiento', '$and','$limit', '$skip', '$sort', 'flag_precalificacion_con_compromiso_de_pago', 'flag_precalificacion_cancelada', 'flag_precalificacion_listo_para_aprobacion'];
      
      // Crear array con los pares key-value formateados
      const pares = [];
      
      for (const [key, value] of Object.entries(params)) {
        if (!excluir.includes(key)) {
          // Validar el valor de la clave
          //let value_validado = JSON.stringify(value);
          let value_validado = value;
    
          if (value === 1 || value === true){
            value_validado = 'Sí';
          }
          if (value === 0 || value === false){
            value_validado = 'No';
          }

          if (JSON.stringify(value_validado) == '{"$in":["Con rectificación y pendientes","Con rectificación"]}'){
            value_validado = 'Con rectificación';
          }

          if (JSON.stringify(value_validado) == '{"$in":["Con rectificación y pendientes","Con Pendientes"]}'){
            value_validado = 'Con pendientes';
          }

          let key_header_title = this.headers.find(header => header.value === key);
          // console.log(key)
          pares.push(`<strong>${key_header_title.text}</strong>: ${value_validado}`);
        }else{
          if (key == 'flag_precalificacion_con_compromiso_de_pago'){
            pares.push(`<strong>Estado de la gestión: </strong>: Con compromiso de pago`);
          }
        }
      }
      
      // Unir todos los pares con comas
      return pares.join(', ');
    },
    /**usar las filas de la columna, para hacer click en gestion */
    handleClick(value) {
      this.fnVerRegistro(value)
    },
    /**
     * *
     * exportar registros a documento de excel*/
    async exportToExcel() {
      try {
        let XLSX = require('xlsx');
        // Obtener todos los registros
        const allRecords = await this.getAllRecords();

        // Preparar los datos para el Excel
        const excelData = allRecords.map((record) => {
          let rowData = {};
          this.headers.forEach((header) => {
            if (header.text != 'Ver') {
              // Usar el 'text' como nombre de columna y 'value' para obtener el dato
              rowData[header.text] = this.formatCellValue(
                record[header.value],
                header.type
              );
            }
          });
          return rowData;
        });

        // Crear una hoja de trabajo
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Crear un libro de trabajo y agregar la hoja
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Registros');

        // Guardar el archivo
        XLSX.writeFile(wb, 'seguimiento de gestiones.xlsx');
      } catch (error) {
        console.error('Error al exportar a Excel:', error);
        // Aquí puedes agregar un manejo de errores más robusto, como mostrar un mensaje al usuario
      }
    },
    async getAllRecords() {
      const totalRecords = this.totalRegistros;
      const params = this.getParams();
      params['$limit'] = totalRecords;
      params['$skip'] = 0;

      try {
        const response = await this.findGestiones({ query: params });
        console.log('todas las gestiones: ', response);
        return response.data;
      } catch (error) {
        console.error('Error al obtener todos los registros:', error);
        throw error;
      }
    },
    formatCellValue(value, type) {
      if (type === 'date') {
        return this.fnGetDate(value);
      }
      if (type === 'datetime') {
        return this.fnGetDateTime(value);
      }
      if (type === 'boolean') {
        return value ? 'Sí' : 'No';
      }
      // Manejar otros tipos según sea necesario
      return value;
    },
    /**
     * *
     * exportar registros a documento de excel, fin*/
    //
    fnGetDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : '';
    },
    fnGetDateTime(date) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm:ss a') : '';
    },
    fnGetDateUTC(date) {
      return date ? moment(date).utc().format('DD-MM-YYYY') : '';
    },
    //GestionesTiemposTranscurridos
    ...mapActions(process.env.VUE_APP_HISTORICO_API_VIEW_GESTIONESTIEMPOSTRANSCURRIDOS, {
      findGestiones: 'find',
      getGestiones: 'get',
      patchGestiones: 'patch',
    }),
    getParams() {
      const params = {};
      /**paginacion */
      params['$limit'] = this.pageSize;
      params['$skip'] = (this.page - 1) * this.pageSize;

      if (
        this.options.sortBy &&
        this.options.sortBy.length === 1 &&
        this.options.sortDesc.length === 1
      ) {
        let sorting = {};
        let flag = this.options.sortDesc[0] ? -1 : 1;
        sorting[this.options.sortBy[0].toString()] = flag;

        console.log('sorting', sorting);
        params['$sort'] = sorting;
      } else {
        params['$sort'] = { id: -1 };
      }
      /**paginacion fin */
      /** parametros de búsqueda */
      /**fechas */
      /** */
      if (this.selectedFecha && this.selectedFecha[0] && this.selectedFecha[1]) {
        /**fechas */
        /** */
        let split1 = this.selectedFecha[0].split('-');
        let split2 = this.selectedFecha[1].split('-');
        let firstDay = new Date(split1[2], split1[1] - 1, split1[0], 0, 0, 0);
        let lastDay = new Date(split2[2], split2[1] - 1, split2[0], 23, 59, 59);
        params['createdAt'] = {
          $gte: firstDay,
          $lte: lastDay,
        };
      }

      /** */
      if (this.selectedAprobacionFecha && this.selectedAprobacionFecha[0] && this.selectedAprobacionFecha[1]) {
        /**fechas */
        /** */
        let split1 = this.selectedAprobacionFecha[0].split('-');
        let split2 = this.selectedAprobacionFecha[1].split('-');
        let firstDay = new Date(split1[2], split1[1] - 1, split1[0], 0, 0, 0);
        let lastDay = new Date(split2[2], split2[1] - 1, split2[0], 23, 59, 59);
        params['flag_precalificacion_concluidas_fecha'] = {
          $gte: firstDay,
          $lte: lastDay,
        };
      }
      /** */

      if (this.SelectedFechasCampania != null) {
        if (this.SelectedFechasCampania[0] && this.SelectedFechasCampania[1]) {
          /**fechas */
          /** */
          let split1 = this.SelectedFechasCampania[0].split('-');
          let split2 = this.SelectedFechasCampania[1].split('-');
          let firstDay = new Date(split1[2], split1[1] - 1, split1[0] - 2, 23, 59, 59);
          let lastDay = new Date(split2[2], split2[1] - 1, split2[0] - 1, 23, 59, 59);
          params['fecha_campania'] = {
            $gte: firstDay,
            $lte: lastDay,
          };
        }
      }
      /** */
      /** */
      if (this.SelectedFechasDeNacimiento != null) {
        if (this.SelectedFechasDeNacimiento[0] && this.SelectedFechasDeNacimiento[1]) {
          /**fechas */
          /** */
          let split1 = this.SelectedFechasDeNacimiento[0].split('-');
          let split2 = this.SelectedFechasDeNacimiento[1].split('-');
          let firstDay = new Date(split1[2], split1[1] - 1, split1[0] - 2, 23, 59, 59);
          let lastDay = new Date(split2[2], split2[1] - 1, split2[0] - 1, 23, 59, 59);
          params['fecha_de_nacimiento'] = {
            $gte: firstDay,
            $lte: lastDay,
          };
        }
      }

      /** */
      if (this.SelectedFechasUltimoComplemento != null) {
        if (this.SelectedFechasUltimoComplemento[0] && this.SelectedFechasUltimoComplemento[1]) {
          /**fechas */
          /** */
          let split1 = this.SelectedFechasUltimoComplemento[0].split('-');
          let split2 = this.SelectedFechasUltimoComplemento[1].split('-');
          let firstDay = new Date(split1[2], split1[1] - 1, split1[0], 0, 0, 0);
          let lastDay = new Date(split2[2], split2[1] - 1, split2[0], 23, 59, 59);
          params['fecha_ultimo_complemento_cargado'] = {
            $gte: firstDay,
            $lte: lastDay,
          };
        }
      }

      if (this.SelectedCancelacionFechas != null) {
        if (this.SelectedCancelacionFechas[0] && this.SelectedCancelacionFechas[1]) {
          /**fechas */
          /** */
          let split1 = this.SelectedCancelacionFechas[0].split('-');
          let split2 = this.SelectedCancelacionFechas[1].split('-');
          let firstDay = new Date(split1[2], split1[1] - 1, split1[0], 0, 0, 0);
          let lastDay = new Date(split2[2], split2[1] - 1, split2[0], 23, 59, 59);
          params['flag_precalificacion_cancelada_fecha'] = {
            $gte: firstDay,
            $lte: lastDay,
          };
        }
      }


      /**fechas */
      /** */
      if (this.nombre) {
        const nombres = this.nombre.split(' ').filter(Boolean); // Separa el término de búsqueda en palabras individuales
        const conditions = nombres.map(nombrePart => {
          return [
            { deudor_nombre_completo: { $like: `%${nombrePart}%` } },
            { primer_nombre: { $like: `%${nombrePart}%` } },
            { segundo_nombre: { $like: `%${nombrePart}%` } },
            { tercer_nombre: { $like: `%${nombrePart}%` } },
            { primer_apellido: { $like: `%${nombrePart}%` } },
            { segundo_apellido: { $like: `%${nombrePart}%` } },
            { tercer_apellido_o_casada: { $like: `%${nombrePart}%` } }
          ];
        });

        // Combina las condiciones de cada palabra en un solo array
        params['$and'] = conditions.map(condGroup => ({ $or: condGroup }));
      }

      if (this.nombre_fiador) {
        const nombresFiador = this.nombre_fiador.split(' ').filter(Boolean); // Divide el término de búsqueda en palabras individuales
        const conditionsFiador = nombresFiador.map(nombrePart => {
          return [
            { fiador_nombre_completo: { $like: `%${nombrePart}%` } },
            { fiador_primer_nombre: { $like: `%${nombrePart}%` } },
            { fiador_segundo_nombre: { $like: `%${nombrePart}%` } },
            { fiador_tercer_nombre: { $like: `%${nombrePart}%` } },
            { fiador_primer_apellido: { $like: `%${nombrePart}%` } },
            { fiador_segundo_apellido: { $like: `%${nombrePart}%` } },
            { fiador_tercer_apellido: { $like: `%${nombrePart}%` } }
          ];
        });

        // Combina las condiciones de cada palabra en un solo array
        params['$and'] = conditionsFiador.map(condGroup => ({ $or: condGroup }));
      }
      /** */
      if (this.documentoIdentificacion) {
        params['dpi'] = {
          $like: '%' + this.documentoIdentificacion + '%',
        };
      }
      /** */
      if (this.documentoIdentificacion) {
        params['dpi'] = {
          $like: '%' + this.documentoIdentificacion + '%',
        };
      }
      /** */
      if (this.search_tiempo_gestion) {
        params['tiempo_transcurrido_total'] = {
          $like: this.search_tiempo_gestion + '%',
        };
      }
      /** */
      if (this.resultadoEvaluacion) {
        if (this.resultadoEvaluacion == 'ROJO') {
          params['resultado_evaluacion'] = 'rechazado';
        }
        if (this.resultadoEvaluacion == 'AMARILLO') {
          params['resultado_evaluacion'] = 'revisión';
        }
        if (this.resultadoEvaluacion == 'VERDE') {
          params['resultado_evaluacion'] = 'aprobado';
        }
      }
      if (this.EstadoDeLaGestion) {
        console.log('estado filtro, vista seguimiento de gestión', this.EstadoDeLaGestion);
        if (this.EstadoDeLaGestion == 'Con rectificación') {
          params['estado'] = { $in: ['Con rectificación y pendientes', 'Con rectificación'] };
        }
        if (this.EstadoDeLaGestion == 'Con Pendientes') {
          params['estado'] = { $in: ['Con rectificación y pendientes', 'Con Pendientes'] };
        }
        if (this.EstadoDeLaGestion == 'Con compromiso de pago') {
          params['flag_precalificacion_con_compromiso_de_pago'] = 1;
          params['flag_precalificacion_cancelada'] = {
            $eq: null,
          };
          params['flag_precalificacion_listo_para_aprobacion'] = {
            $eq: null,
          };
        }

        else if (this.EstadoDeLaGestion != 'Con rectificación' && this.EstadoDeLaGestion != 'Con Pendientes') {
          params['estado'] = this.EstadoDeLaGestion;
        }

      }
      /** */
      if (this.sector) {
        params['sector'] = this.sector;
      }
      if (this.region) {
        params['region'] = {
          $like: '%' + this.region + '%',
        }
      }
      if (this.division) {
        params['division'] = {
          $like: '%' + this.division + '%',
        }
      }
      if (this.search_nit) {
        params['nit'] = this.search_nit;
      }
      /** */
      if (this.campania) {
        params['campania'] = this.campania;
      }
      if (this.ruta) {
        params['ruta'] = this.ruta;
      }
      if (this.searchTipoDeCliente) {
        params['buro_tipo_de_usuario'] = this.searchTipoDeCliente;
      }
      if (this.id) {
        params['id'] = this.id
      }
      if (this.sap) {
        params['codigo_sap'] = this.sap
      }
      if (this.search_pedido) {
        if (this.search_pedido == 'Si') {
          params['flag_tiene_pedido'] = 1
        }

        if (this.search_pedido == 'No') {
          params['flag_tiene_pedido'] = 0
        }
      }
      if (this.usuarios) {
        params['$or'] = [
          {
            CREADO_POR_USUARIO: {
              $like: '%' + this.usuarios + '%',
            },
          },
          {
            CREADO_POR_USUARIO_NOMBRE: {
              $like: '%' + this.usuarios + '%',
            },
          }
        ];


      }
      if (this.compromiso_aprobado) {
        params['compromiso_aprobado'] = this.compromiso_aprobado;
      }
      if (this.rectificaciones_completadas != null) {
        params['rectificaciones_completadas'] = this.rectificaciones_completadas;
      }
      /** parametros de búsqueda, fin */

      return params;
    },
    main() {
      this.table_loading = true;
      console.log('aplicanco parámetros de búsqueda', this.getParams());
      this.findGestiones({ query: this.getParams() }).then((r) => {
        for (let index = 0; index < r.data.length; index++) {
          /**dar formato al campo "fullName", desplieigue en tabla */
          const element = r.data[index];
          //console.log('flag_precalificacion_listo_para_aprobacion_fecha', element.flag_precalificacion_listo_para_aprobacion_fecha);
          let fullName = [
            element.primer_nombre,
            element.segundo_nombre,
            element.tercer_nombre,
            element.primer_apellido,
            element.segundo_apellido,
            element.tercer_apellido_o_casada,
          ]
            .filter(Boolean)
            .join(' ');

          r.data[index].nombre_completo = fullName;
        }
        /**dar formato al campo "fullName", desplieigue en tabla */
        /** */
        this.datosTabla = r.data;
        this.total_precalificaciones = r.total;
        /** */
        this.totalRegistros = r.total;
        this.totalPages = Math.ceil(
          parseInt(r.total) / parseInt(this.pageSize)
        );
        this.table_loading = false;
      }).catch(e => {
        this.$notify({
          title: 'Error',
          text: e,
          color: '#E53935',
          timeout: 3000,
        });

        this.table_loading = false;
      });
    },
    /**paginacion */
    handlePageChange(value) {
      this.page = value;
      this.main();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.main();
    },
    /**paginacion fin */

    fnVerRegistro(data) {
      console.log(data);
      this.$router.push('/detalle-gestion-historico/' + data.id);
    },

    //funcion para recopilar toda la información cuando se da clic en el botón de aplicar parámetros (en la card de búsqueda)
    fnAplicarParametros() {

      this.page = 1;

      this.main();
    },

    //funcion para mostrar el recuadro verde la esquina superior derecha que indica que se finalizó la revisión
    fnFinalizacionRevision() {
      const revision = localStorage.getItem('evaluacion');
      if (revision) {
        console.log('se terminó una revisión');
        this.snackbar = true;

        this.datosTabla = []; //Se borran los datos de la tabla, como ejemplo nada mas
      } else {
        console.log('no se revisó nada');
      }

      localStorage.removeItem('evaluacion'); //eliminamos la info almacenada de revisión
    },
  },

  watch: {
    options: {
      // eslint-disable-next-line no-unused-vars
      handler(newValue) {
        this.main();
      },
      deep: true,
      immediate: true,
    },
    /** parametrización por fechas con el calendario*/
    dialogVarSelectedFecha(newValue) {
      if (newValue) {
        this.selectedFecha = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.selectedFecha = [
          null,
          null
        ];
      }

    },
    dialogVarselectedAprobacionFecha(newValue) {
      if (newValue) {
        this.selectedAprobacionFecha = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.selectedAprobacionFecha = [
          null,
          null,
        ];
      }

    },
    dialogVarSelectedFechasCampania(newValue) {
      if (newValue != null) {
        this.SelectedFechasCampania = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.SelectedFechasCampania = [null, null
        ];
      }
    },
    dialogVarSelectedFechasDeNacimiento(newValue) {
      if (newValue != null) {
        this.SelectedFechasDeNacimiento = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.SelectedFechasDeNacimiento = [null, null
        ];
      }
    },
    dialogVarSelectedFechasUltimoComplemento(newValue) {
      if (newValue != null) {
        this.SelectedFechasUltimoComplemento = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.SelectedFechasUltimoComplemento = [null, null
        ];
      }
    },
    dialogVarSelectedCancelacionFechas(newValue) {
      if (newValue != null) {
        this.SelectedCancelacionFechas = [
          moment(newValue[0]).format('DD-MM-YYYY'),
          moment(newValue[1]).format('DD-MM-YYYY'),
        ];
      } else {
        this.SelectedCancelacionFechas = [null, null
        ];
      }
    },
  },
  /** */
  mounted() {
    this.main();
  },

  //para verificar si regresamos de alguna revisión al ejecutar el componente (únicamente para pruebas)
  created() {
    this.fnFinalizacionRevision();
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 2px;
}
</style>
